<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent slim-toolbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row" style="padding: 0;padding-left: 14px;">
      <div class="md-toolbar-section-start">
        <!-- <img src=""> -->
        <div style="height: 43px; width: 43px;border-radius: 23px;background: #D9D9D9;"></div>
        <h3 style="font-size: 18px;font-weight: 400;color: #FFF;font-family: Microsoft YaHei;margin: -1px 0 -1px 6px;line-height: 52px;height: 52px;">{{$I18n("top_title")}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button @click="openServerModal = true" class="md-just-icon md-round md-simple md-toolbar-toggle">
          <svg style="margin-top: 13px;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-120q-151 0-255.5-46.5T120-280v-400q0-66 105.5-113T480-840q149 0 254.5 47T840-680v400q0 67-104.5 113.5T480-120Zm0-479q89 0 179-25.5T760-679q-11-29-100.5-55T480-760q-91 0-178.5 25.5T200-679q14 30 101.5 55T480-599Zm0 199q42 0 81-4t74.5-11.5q35.5-7.5 67-18.5t57.5-25v-120q-26 14-57.5 25t-67 18.5Q600-528 561-524t-81 4q-42 0-82-4t-75.5-11.5Q287-543 256-554t-56-25v120q25 14 56 25t66.5 18.5Q358-408 398-404t82 4Zm0 200q46 0 93.5-7t87.5-18.5q40-11.5 67-26t32-29.5v-98q-26 14-57.5 25t-67 18.5Q600-328 561-324t-81 4q-42 0-82-4t-75.5-11.5Q287-343 256-354t-56-25v99q5 15 31.5 29t66.5 25.5q40 11.5 88 18.5t94 7Z"/></svg>
        </md-button>
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse" >
          <md-list>
            <li v-if="organi.length > 0" class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content" >
                  <drop-down direction="down" >
                    <md-button
                      slot="title"
                      class="md-button md-simple"
                      data-toggle="dropdown"
                    >
                      <p style="margin: 0;color: #FFF !important;">{{use_organi.name}}</p>
                      <md-icon class="dropdown-arrow" style="color: #FFF !important;">keyboard_arrow_up</md-icon>
                    </md-button>
                    <ul class="menu_li dropdown-menu dropdown-menu-right">
                      <li v-for="item in organi" :key="item.id" @click="changeOrga(item)">
                        <p>
                          {{item.name}}
                        </p>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            <li class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-simple"
                      data-toggle="dropdown"
                    >
                      <p style="margin: 0;color: #FFF !important;">{{use_organi.user_name}}</p>
                      <md-icon class="dropdown-arrow" style="color: #FFF !important;">keyboard_arrow_up</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <!-- 修改密码 -->
                      <li><a href="#" @click="changePw">{{$I18n("change_pw")}}</a></li>
                      <!-- 登出 -->
                      <li><a href="#" @click="checkExit">{{$I18n("logout")}}</a></li>


                      <!-- <li>
                        <router-link :to="{path:'/user/info', query: {...$router.history.current.query}}">
                          <p :style="{'margin':0}" @click="changeMenuName($I18n('personal_info'))">
                            {{$I18n("personal_info")}}
                          </p>
                        </router-link>
                      </li> -->
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
    <modal 
      v-show="openModal" 
      @close="modal_classicModalHide" 
      class="lg-modal" 
      :mid-modal="typeModal === 'changepw'"
    >
      <template slot="header">
        <h4 class="modal-title">{{$I18n("change_pw")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template v-if="typeModal === 'changepw'" slot="body">
        <div>
          <common-form-item 
            style="margin-bottom: 16px;"
            :labelweight="190"
            v-for="item in formItem" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
      <template v-if="typeModal === 'logout'" slot="body">
        {{$I18n("check_logout")}}
      </template>
      <template slot="footer">
        <md-button :style="{'margin-right':'16px'}" class="md-info" @click="modal_submit">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancle")}}</md-button>
      </template>
    </modal>
  </md-toolbar>
</template>

<script>
import { passwordLegal, FormClass } from "@/common/tools.js";
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  props : {
    organi:{
      type: Array,
      default: () => [], 
    },

  },
  created(){},
  data() {
    return {
      use_organi: {},
      openModal : false,
      typeModal : '',
      formData  : new FormClass({
        old_pw    : {
          init    : "",
          check   : "required",
        },
        new_pw    : {
          init    : "",
          check   : val => {
            return !passwordLegal(val)
          },
        },
        con_new_pw: {
          init    : "",
          check   : (val, form) => {
            return val !== form.new_pw
          },
        },
      }),
    }
  },
  computed:{ 
    formItem(){
      return  [
        {
          label   : this.$I18n("old_pw"),
          keys    : "old_pw",
          type    : "input",
          check   : true,
          required: true,
          placeholder: this.$I18n('pls_input'),
        },{
          label   : this.$I18n("new_pw"),
          keys    : "new_pw",
          type    : "input",
          check   : true,
          required: true,
          placeholder: this.$I18n('pls_input'),
        },{
          label   : this.$I18n("con_new_pw"),
          keys    : "con_new_pw",
          type    : "input",
          check   : true,
          required: true,
          placeholder: this.$I18n('pls_input'),
        }
      ]
    },
  },
  watch:{
    use_organi:{
      handler(newValue){
        if(newValue.name){
          this.$emit('useOtherOrgani', newValue.id);
        } else {
          this.$emit('useOtherOrgani', '');
        }
      },
      immediate: true,
      deep: true,
    },
    organi(newValue){
      if(newValue.length > 0){
        if(!this.use_organi.name && !this.use_organi.id){
          this.use_organi = {...newValue[0]}
        } else {
          const sameOrgani = newValue.filter(i => this.use_organi.id === i.id)[0];
          if(sameOrgani){
            this.use_organi = {...sameOrgani}
          }
        }
      }
    },
  },
  methods: {
    changeOrga(item){
      console.log(item.role_id)
      if(item.role_id === 3){
        this.$errorMsg(this.$I18n("no_role"), 3000)
        return
      }
      this.use_organi = {...item}
    },
    // changeMenuName(name){
    //   this.$emit('changeName', name)
    // },
    api_changepw(){
      if(!passwordLegal(this.formData.Form.new_pw)){
        this.$errorMsg(this.$I18n("pls_input_password_2"), 2000)
        return 
      } else if(this.formData.Form.con_new_pw !== this.formData.Form.new_pw) {
        this.$errorMsg(this.$I18n("pw_no_same"), 2000)
        return 
      }
      
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(210,window.appConfig.umeye_api(isHttps, localStorage.umh_host), {
        client_id  : "web",
        client_type: 6,
        enc_type   : 2,
        old_passwd: this.formData.Form.old_pw,
        new_passwd: this.formData.Form.new_pw,
        ver_type  : 0,
        user_id   : this.UserInfo.user_id,
      })
        // 处理回调
        .then(res => {
          if(res.h.e == 200){
            this.$successMsg(this.$I18n("pass_change_succ"));
          } else if(res.h.e == 512){
            this.$errorMsg(this.$I18n("org_pw_error"), 3000)
          // } else if(res.h.e == 8027){
          //   this.$errorMsg(this.$I18n("org_pw_error"), 3000)
          } else {
            this.$errorMsg(this.$I18n("edit_fail"), 3000)
          }
          
          return
        })
        .catch(this.$Catch(this.$I18n("get_error")));
    },
    api_logout(){
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(203,window.appConfig.umeye_api(isHttps, localStorage.umh_host), {
        client_id: "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        disable_push: 0,
      })
        // 处理回调
        .catch(() => {})
        .then(() => {
          this.$successMsg(this.$I18n("logout_succ"));
          localStorage.acc_token = "";
          localStorage.umh_host = "";
          this.$router.push({
            path :"/login",
            query:this.$router.history.current.query,
          }).catch(() => {});
          
          // window.location.href = window.location.origin + "/login" + window.location.search;
          return
        })
    },
    // 登出
    modal_submit(){
      if(this.typeModal === 'logout'){
        this.api_logout();
      } else if(this.typeModal == 'changepw') {
        this.api_changepw();
      }
    },
    changePw(){
      this.openModal = true;
      this.formData.Reset();
      this.typeModal = 'changepw';
    },
    checkExit(){
      // this.openModal = true;
      this.typeModal = 'logout';
      /* Body | title */
      setTimeout(() => {
        this.$confirm(this.$I18n("check_logout"), this.$I18n("log_out"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          closeOnHashChange: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          this.modal_submit();
        }).catch(() => { })
      }, 500)
    },
    modal_classicModalHide(){
      this.openModal = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
};
</script>
<style scoped>
  .menu_li p{
    padding:0 20px;
  }
  .menu_li li p{
    margin: 0;
    padding: 14px 20px;
  }
  .menu_li li:hover{
    background: #DDD;
    transition: background .2s;
  }
</style>